import {
  GETTER_FILES,
  GETTER_FILES_FETCHING,
  GETTER_FILES_FROM_DOC,
  GETTER_FILES_FROM_DOC_PRESCRIPTIONS,
  GETTER_FILES_FROM_DOC_LAB_TESTS,
  GETTER_FILES_FROM_DOC_OTHER_NOTES,
  GETTER_FILES_STATE,
  GETTER_FILES_WITH_PROGRAM,
  ACTION_SET_FILES_STATE,
  ACTION_SET_FILE_ORDER_ID,
  MUTATE_FILES_STATE,
  MUTATE_FILE_ORDER_ID,
} from './types';

import {
  updateStateProps,
  mutateStateProps,
} from './common-functions';

import {PageTypes} from "@/reference";
import {DEFAULT_PHARMACIES} from "@/reference/medicine";
import {
  getPrescriptionCoupon,
  isCouponProgram,
} from "@/utils/medicine";

import moment from "moment";

const defaultState = () => ({
  fetching: false,
  files: [],
  initialized: false,
});

const state = defaultState();

const getters = {
  [GETTER_FILES_STATE]: (state) => state,
  [GETTER_FILES]: ({files}) => files,
  [GETTER_FILES_FETCHING]: ({fetching}) => fetching,
  [GETTER_FILES_FROM_DOC]: ({files}) => {
    return files
      .slice(0)
      // dont display home service results yet
      .filter((file) => !(file.sourcelab === DEFAULT_PHARMACIES.amplify && file.loaId))
      .sort((a, b) => {
        const aReceivedDate = a.received || a.datereceived;
        const bReceivedDate = b.received || b.datereceived;

        return moment(bReceivedDate).valueOf() - moment(aReceivedDate).valueOf();
      });
  },
  [GETTER_FILES_FROM_DOC_PRESCRIPTIONS]: (state, getters) => {
    return getters[GETTER_FILES_FROM_DOC].filter(sf => sf.pagetype === PageTypes.prescription);
  },
  [GETTER_FILES_FROM_DOC_LAB_TESTS]: (state, getters) => {
    return getters[GETTER_FILES_FROM_DOC]
      .filter(sf => {
        return sf.pagetype === PageTypes.labtest ||
               sf.pagetype === PageTypes.labpage ||
               sf.pagetype === PageTypes.__labresults ||
               (sf.sourcelab === DEFAULT_PHARMACIES.hipres && sf.loaId) // lab result
              //  (sf.sourcelab === DEFAULT_PHARMACIES.amplify && sf.loaId); dont display home service results yet
      });
  },
  [GETTER_FILES_FROM_DOC_OTHER_NOTES]: (state) => {
    return state.files.filter(file => file.pagetype === PageTypes.educ);
  },
  [GETTER_FILES_WITH_PROGRAM]: (state, getters) => {
    return getters[GETTER_FILES].filter(file => {
      const prescriptionCoupon = getPrescriptionCoupon(file);
      return isCouponProgram(prescriptionCoupon);
    });
  },
};

const actions = {
  [ACTION_SET_FILES_STATE]: updateStateProps(MUTATE_FILES_STATE),
  [ACTION_SET_FILE_ORDER_ID]: ({commit}, argObject) => {
    commit(MUTATE_FILE_ORDER_ID, argObject);
  },
};

const mutations = {
  [MUTATE_FILES_STATE]: mutateStateProps,
  [MUTATE_FILE_ORDER_ID]: (state, {uploadid, orderid}) => {
    const fileIndex = state.files.findIndex((file) => file.uploadid === uploadid);

    if (fileIndex >= 0) {
      state.files.splice(fileIndex, 1, {...state.files[fileIndex], orderid});
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
